import { generateExpWithNum } from './generateExpWithNum';
import { declensions } from '../constants/declensions';

export const getHousePageSubtitle = (house, flatTenants) => {
  if (flatTenants) {
    const tenantText = generateExpWithNum(
      flatTenants.length,
      declensions.registeredResidents
    );

    return tenantText;
  }

  if (house) {
    const { porchCount, flatCount, clientCount } = house;

    const entranceText = porchCount
      ? `${generateExpWithNum(porchCount, declensions.porchs)} / `
      : '';

    const flatText = flatCount
      ? `${generateExpWithNum(flatCount, declensions.flats)} / `
      : '';

    const tenantText = clientCount
      ? generateExpWithNum(clientCount, declensions.registeredResidents)
      : '';

    return `${entranceText}${flatText}${tenantText}`;
  }

  return '';
};
